import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ProfileLink = styled(Link)`
  /* display: inline-block; */
  width: 40px;
  height: 40px;
  padding: 0 20px;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #000;
  margin-left: 1rem;
  text-decoration: none;
  /* center content inside */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: bold;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`;

function ProfileIcon({ to, username }) {
  return (
    <ProfileLink to={to}>
      {username}
    </ProfileLink>
  );
}

export default ProfileIcon;
